module.exports = __webpack_public_path__ + "img/logo_konkatsu03.f93ee5ff.png";